export default __webpack_public_path__ + "static/media/clock-green-icon.e3aa4d9c.svg";